// Axios
import axios from 'axios';

// Endpoints
import { ENDPOINTS_POST, ENDPOINTS_PUT, ENDPOINTS_GET, ENDPOINTS_DELETE, ENDPOINTS_PATCH } from '@/app/apis/main/_connection/connection-endpoints.js';

// Interceptor
import { apiInterceptor } from '@/app/apis/main/_connection/connection-interceptors.js';

// API Instance
export const instance = axios.create({
	baseURL: process.env.VUE_APP_BASE_URL,
	headers: {},
	timeout: 20000, // 20 seconds
	validateStatus: status => {
		return status;
	},
});

// API Interceptors
apiInterceptor(instance);

// API Methods
export const API = {
	post(endpoint, formData, timeout) {
		return instance.post(endpoint, formData, timeout);
	},
	put(endpoint, formData, timeout) {
		return instance.put(endpoint, formData, timeout);
	},
	get(endpoint, params) {
		return instance.get(endpoint, { params });
	},
	delete(endpoint, formData) {
		return instance.delete(endpoint, formData);
	},
	patch(endpoint, formData) {
		return instance.patch(endpoint, formData);
	}
}

// API Endpoints
export const ENDPOINTS = {
	...ENDPOINTS_POST,
	...ENDPOINTS_PUT,
	...ENDPOINTS_GET,
	...ENDPOINTS_DELETE,
	...ENDPOINTS_PATCH
}